var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Profile = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 18 20" }),
        React.createElement("path", { d: "M8.5 10.5C5.73857625 10.5 3.5 8.26142375 3.5 5.5 3.5 2.73857625 5.73857625.5 8.5.5 11.2614237.5 13.5 2.73857625 13.5 5.5 13.5 6.82608245 12.9732158 8.09785201 12.0355339 9.03553391 11.097852 9.9732158 9.82608245 10.5 8.5 10.5zM8.5 1.5C6.290861 1.5 4.5 3.290861 4.5 5.5 4.5 7.709139 6.290861 9.5 8.5 9.5 10.709139 9.5 12.5 7.709139 12.5 5.5 12.5 4.43913404 12.0785726 3.42171839 11.3284271 2.67157288 10.5782816 1.92142736 9.56086596 1.5 8.5 1.5zM16 19.5L2 19.5C1.80880245 19.5003826 1.63412671 19.3916955 1.55 19.22L.33 16.88C.245499126 16.6984795.272724341 16.4845671.4 16.33 2.39761123 14.1679209 5.12023501 12.8155064 8.05 12.53 11.24 12.3 14.44 13.53 17.55 16.28 17.721992 16.4293225 17.7713301 16.6760131 17.67 16.88L16.49 19.22C16.3999843 19.4054014 16.2054307 19.5165749 16 19.5zM2.22 18.5L15.74 18.5 16.6 16.78C13.8 14.42 10.96 13.32 8.13 13.52 5.57835241 13.7808465 3.19623919 14.9188887 1.39 16.74L2.22 18.5z" })));
};
export default Profile;
